import React, { useCallback, useMemo, useEffect } from 'react';
import css from './styles.module.scss';
import { Box, Typography } from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import { getDealTypeList, selectNewDeal } from '~/features/dashboard/store/selectors';
import { StepControls } from '~/common/step-controls';
import { INewDealStepOneFormInputs } from '~/models/deals/new-deal/formInputs';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { createNewDealStepOneThunk, getDealTypes } from '~/features/dashboard/store/actions.thunks';
import { useRouteMatch } from 'react-router-dom';

interface Step_1Props {}

export const Step_1: React.FC<Step_1Props> = () => {
    const match = useRouteMatch<{ creatorId: string }>();
    const creatorId = useMemo(() => Number(match.params.creatorId), [match.params.creatorId]);
    const newDealState = useSelector(selectNewDeal);
    const dispatch = useThunkDispatch();

    const {
        handleSubmit,
        register,
        errors,
        formState: { isDirty },
        reset,
        control,
        watch,
        setValue,
    } = useForm<INewDealStepOneFormInputs>({
        defaultValues: {
            dealName: newDealState?.contractTitle || '',
            dealType: newDealState?.contractSubTypeList[0]?.accStatusUseId || 20,
        },
    });

    let watchContractType = watch('dealType');
    let dealTypes = useSelector(getDealTypeList);

    useEffect(() => {
        dispatch(getDealTypes());
    }, [dispatch]);

    useEffect(() => {
        if (newDealState?.contractType && dealTypes) {
            let name: string = newDealState?.contractType;
            let nameUpper: string = name.toUpperCase();
            dealTypes.map((item: any): any => {
                if (item.name === nameUpper) {
                    setValue('dealType', Number(item.id));
                }
                return item;
            });
        }
    }, [newDealState, dealTypes, setValue]);

    const onSubmit = useCallback(
        (data: INewDealStepOneFormInputs) => {
            let contractSubTypeList = newDealState?.contractSubTypeList || [];
            let contractType = (dealTypes || []).find((item) => item.id === Number(data.dealType))?.name;
            if (newDealState?.contractType !== contractType) {
                contractSubTypeList = [];
            }
            dispatch(createNewDealStepOneThunk({ ...data, contractType, contractSubTypeList, creatorId, isDirty }));
        },
        [creatorId, dispatch, isDirty, dealTypes, newDealState]
    );

    useEffect(() => {
        if (newDealState === null) {
            reset({ dealName: '' });
        }
    }, [newDealState, reset]);

    return (
        <Box className={css.module}>
            <Box className={css.wrapper}>
                <form className={css.form} onSubmit={handleSubmit(onSubmit)}>
                    <Typography align={'center'} variant={'h4'} className={css.songtitle}>
                        Give your deal a name
                    </Typography>
                    <Typography className={css.descText}>
                        Once you have given your deal a name, you can tag anything you deliver or need with this deal to the file.
                    </Typography>
                    <TextField
                        className={css.input}
                        variant="filled"
                        fullWidth
                        autoFocus
                        name={'dealName'}
                        inputRef={register({ required: 'Deal name is required' })}
                        error={!!errors.dealName}
                        helperText={errors.dealName ? errors.dealName.message : ''}
                    />
                    <Typography align={'center'} variant={'h4'} className="songtitle">
                        What type of deal is it?
                    </Typography>

                    <div className={css.keyReasonsCheckBox}>
                        <Controller
                            defaultValue={watchContractType || 20}
                            render={props => (
                                <div className={css.optionsContainer}>
                                    {dealTypes?.map((item: any, index: any) => (
                                        <label key={index} className={css.keyReasonsCheckBox}>
                                            <input
                                                type="radio"
                                                // ref={register({ required: true })}
                                                value={item.id || watchContractType}
                                                checked={String(props.value) === String(item.id)}
                                                name={'contractType'}
                                                onChange={props.onChange}
                                            />
                                            <div className={'newdesign'}>
                                                <span>{item.name}</span>
                                            </div>
                                        </label>
                                    ))}
                                </div>
                            )}
                            name={'dealType'}
                            control={control}
                        />
                    </div>
                    <StepControls errors={errors} />
                </form>
            </Box>
        </Box>
    );
};
